
import { Form, DatePicker, TextField } from "../util";
import { defineComponent } from "vue";

import { PatientBody } from "@/domain/params";
import { mapActions, mapState } from "vuex";
import { patientService } from "@/domain/services";
import hash from "object-hash";

type ComponentData = {
  isLoading: boolean;
  field_valid: { [field: string]: boolean };
  body: PatientBody;
};

export default defineComponent({
  name: "PatientForm",
  components: {
    Form,
    DatePicker,
    TextField,
  },
  data(): ComponentData {
    const patient_id = this.$store.state.record.patient_id;
    const body = { ...this.$store.state.record.patient };

    return {
      isLoading: false,
      field_valid: {
        name: !!patient_id,
        phone: !!patient_id,
        cpf: !!patient_id,
      },
      body,
    };
  },
  async created() {
    if (this.patient_id && !this.hash_patient)
      patientService.getById(this.patient_id).then((patient) => {
        this.body.name = patient.name;
        this.body.phone = patient.phone.maskPhone();
        this.body.birthdate = patient.birthdate;
        this.body.address = patient.address;
        this.body.registration = patient.registration;
        this.body.cpf = patient.cpf.maskCpf();

        this.setHashPatient(hash(this.body));
      });
  },
  computed: {
    isFormValid() {
      for (let field_name in this.field_valid)
        if (!this.field_valid[field_name]) return false;
      return true;
    },
    ...mapState("record", ["patient", "patient_id", "hash_patient"]),
    ...mapState("agenda", ["professional_id"]),
  },
  methods: {
    ...mapActions({
      loadSchedules: "schedules/load",
      resetCloseNewAppointment: "record/resetCloseNewAppointment",
      setRecordPatientId: "record/setRecordPatientId",
      setRecordPatient: "record/setRecordPatient",
      setHashPatient: "record/setHashPatient",
    }),
    updateValidation(field: string, valid: boolean) {
      this.field_valid[field] = valid;
    },
    save() {
      this.isLoading = true;
      const payload = { ...this.body };

      if (this.patient_id && this.hash_patient != hash(this.body))
        return patientService.update(this.patient_id, payload as PatientBody).then(() => {
          this.isLoading = false;
        });
      else if (!this.patient_id)
        return patientService.create(this.body as PatientBody).then((patient) => {
          this.setRecordPatientId(patient.id);
          this.isLoading = false;
        });
      this.isLoading = false;
    },
  },
  beforeUnmount() {
    this.setRecordPatient(this.body);
  },
});
